import { LayoutConst } from "core/modules/layout.module";
import styled, { css } from "styled-components";

export const PaymentErrorWrapper = styled.div<{
    transparent?: boolean
    mobile?: boolean
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: ${p => p.mobile ? "95vw" : "min(90vw, 1152px)"};
    padding: ${p => p.mobile ? "16px" : "56px 0 72px"};
    margin: ${p => p.mobile ? "24px 0" : "48px 0"};
    background-color: ${p => p.transparent ? "transparent" : p.theme.sendGift.background};
    /* box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05); */
    border-radius: 8px;
    text-align: center;
`

export const PaymentErrorOuterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1049px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        padding: 16px;
        max-width: 400px;
    }
`

export const ErrorTitle = styled.div<{
    mobile?: boolean
    isDarkTheme?: boolean
}>`
    text-align: center;

    font-family: Inter;
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px; /* 118.605% */
    letter-spacing: -0.86px;

    ${({ isDarkTheme, theme }) => isDarkTheme && css`
        color: ${theme.sendProjectsModal.title};
    `}

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
        letter-spacing: -0.4px;
    }
`

export const ErrorInfo = styled.div`
    width: 100%;
   
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 133.333% */
    letter-spacing: -0.6px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }
`

export const CardFinalInfo = styled.div`
    display: flex;
    width: 100%;
`

export const FinalCard = styled.img<{
    mobile?: boolean
}>`
    max-height: 150px;
    max-width: 150px;
    object-fit: contain;
    object-position: top;
    margin-right: ${p => p.mobile ? "0" : "24px"};;
    margin-bottom: ${p => p.mobile ? "24px" : "0"};
`

export const FinalGiftText = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    margin-top: 8px;
    margin-bottom: 16px;
    color: ${p => p.theme.sendGift.text}
`

export const ErrorText = styled.div<{
    mobile?: boolean
    mb?: number
    isDarkTheme?: boolean
}>`
    text-align: center;
    margin-top: 16px;
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 133.333% */
    letter-spacing: -0.6px;
    margin-bottom: 40px;

    ${({ isDarkTheme, theme }) => isDarkTheme && css`
      color: ${theme.sendProjectsModal.title};
    `}

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        margin-top: 8px;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
        margin-bottom: 24px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
    }
`

export const ButtonTypography = styled.div<{ fs?: number, fw?: number, lh?: number }>`
    font-family: Inter;
    font-size: ${p => p.fs || 17}px;
    font-weight: ${p => p.fw || 600};
    line-height: ${p => p.lh || 22};
`import { LayoutConst } from "core/modules/layout.module";
import styled, { css } from "styled-components";

export const PaymentErrorWrapper = styled.div<{
    transparent?: boolean
    mobile?: boolean
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: ${p => p.mobile ? "95vw" : "min(90vw, 1152px)"};
    padding: ${p => p.mobile ? "16px" : "56px 0 72px"};
    margin: ${p => p.mobile ? "24px 0" : "48px 0"};
    background-color: ${p => p.transparent ? "transparent" : p.theme.sendGift.background};
    /* box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05); */
    border-radius: 8px;
    text-align: center;
`

export const PaymentErrorOuterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1049px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        padding: 16px;
        max-width: 400px;
    }
`

export const ErrorTitle = styled.div<{
    mobile?: boolean
    isDarkTheme?: boolean
}>`
    text-align: center;

    font-family: Inter;
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px; /* 118.605% */
    letter-spacing: -0.86px;

    ${({ isDarkTheme, theme }) => isDarkTheme && css`
        color: ${theme.sendProjectsModal.title};
    `}

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
        letter-spacing: -0.4px;
    }
`

export const ErrorInfo = styled.div`
    width: 100%;
   
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 133.333% */
    letter-spacing: -0.6px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }
`

export const CardFinalInfo = styled.div`
    display: flex;
    width: 100%;
`

export const FinalCard = styled.img<{
    mobile?: boolean
}>`
    max-height: 150px;
    max-width: 150px;
    object-fit: contain;
    object-position: top;
    margin-right: ${p => p.mobile ? "0" : "24px"};;
    margin-bottom: ${p => p.mobile ? "24px" : "0"};
`

export const FinalGiftText = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    margin-top: 8px;
    margin-bottom: 16px;
    color: ${p => p.theme.sendGift.text}
`

export const ErrorText = styled.div<{
    mobile?: boolean
    mb?: number
    isDarkTheme?: boolean
}>`
    text-align: center;
    margin-top: 16px;
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 133.333% */
    letter-spacing: -0.6px;
    margin-bottom: 40px;

    ${({ isDarkTheme, theme }) => isDarkTheme && css`
      color: ${theme.sendProjectsModal.title};
    `}

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        margin-top: 8px;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
        margin-bottom: 24px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
    }
`

export const ButtonTypography = styled.div<{ fs?: number, fw?: number, lh?: number }>`
    font-family: Inter;
    font-size: ${p => p.fs || 17}px;
    font-weight: ${p => p.fw || 600};
    line-height: ${p => p.lh || 22};
`